/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AssignCompaniesRole {
  AccountExec = "AccountExec",
  CustomerSuccess = "CustomerSuccess",
}

export function instanceOfAssignCompaniesRole(value: any): boolean {
  for (const key in AssignCompaniesRole) {
    if (Object.prototype.hasOwnProperty.call(AssignCompaniesRole, key)) {
      if (
        AssignCompaniesRole[key as keyof typeof AssignCompaniesRole] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AssignCompaniesRoleFromJSON(json: any): AssignCompaniesRole {
  return AssignCompaniesRoleFromJSONTyped(json, false);
}

export function AssignCompaniesRoleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AssignCompaniesRole {
  return json as AssignCompaniesRole;
}

export function AssignCompaniesRoleToJSON(
  value?: AssignCompaniesRole | null,
): any {
  return value as any;
}

export function AssignCompaniesRoleToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AssignCompaniesRole {
  return value as AssignCompaniesRole;
}
